import { render } from "./Comments.vue.js?vue&type=template&id=3f0597e3!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comments.vue?vue&type=template&id=3f0597e3"
import script from "./Comments.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/comments-widget/Comments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f0597e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f0597e3', __exports__)) {
    api.reload('3f0597e3', __exports__)
  }
  
  module.hot.accept("./Comments.vue.js?vue&type=template&id=3f0597e3!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comments.vue?vue&type=template&id=3f0597e3", () => {
    api.rerender('3f0597e3', render)
  })

}


export default __exports__